// NPM Imports
import React, { Component } from "react";
import { connect } from "react-redux";
import Modal from "react-responsive-modal";
import { Toastr, Button, Label } from "@revvsales/components";

// Comonents Imports

// Actions Imports
import { updateTemplateTitle } from "../../actions/DocumentTemplateActions/templateService";
import { fetchAllDocumentTemplates } from "../../actions/DocumentTemplateActions/templateActions";

const ENTER_KEY = 13;

class TemplateNameEditPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: props.title,
      showButtunLoader: false,
      errMsg: "",
    };
  }

  componentDidMount() {
    this.templateNameInput.focus();
    this.setState({
      title: this.props.docName,
    });
  }

  _onInputChange = event => {
    this.setState({
      title: event.target.value,
      errMsg: "",
    });
  };

  _toggleLoader = (type, flag) => {
    this.setState({ [type]: flag });
  };

  _onSubmit = () => {
    const { title } = this.state;
    if (this.props.purpose === "RENAME ONLY") {
      this._updateTempDetails(title);
    } else if (title !== this.props.docName) {
      this._updateTempDetails(title);
    } else {
      const { stripePaymentDetails, buttonData } = this.props;
      if (
        buttonData.length &&
        ((stripePaymentDetails && !stripePaymentDetails.is_active) ||
          !stripePaymentDetails)
      ) {
        // if there is a disabled button in the doc
        this.props.updateMultipleState({
          showEditTemplateNamePopup: false,
          stripeButtonRemovePopup: true,
          buttonValue: "templatePublish",
        });
      } else {
        this.props.updateMultipleState({
          showEditTemplateNamePopup: false,
          showPublishTemplatePopup: true,
        });
      }
    }
  };

  _updateTempDetails = value => {
    console.debug("value", value);
    const { title, templateId } = this.props;
    const data = [
      {
        op: "replace",
        value: {
          title: this.state.title,
        },
      },
    ];

    if (this.props.templateStatus === "ACTIVE") {
      Toastr.showToastr({
        type: "warning",
        message: "Active templates cannot be renamed.",
        timeout: 3000,
      });

      return;
    }

    updateTemplateTitle(templateId, data)
      .then(response => {
        this.setState({
          title: response.Template.title,
        });
        if (this.props.purpose === "RENAME ONLY") {
          this.props.fetchAllDocumentTemplates();
          Toastr.showToastr({
            type: "success",
            message: "Template renamed successfully.",
            timeout: 3000,
          });
        } else {
          this.props.updateTemplateTitle(response.Template.title);
        }
      })
      .catch(() => {
        Toastr.showToastr({
          type: "failure",
          message:
            "The name of the template could not be changed. Please try again.",
          timeout: 3000,
        });
        this.setState({
          title,
        });
        this.props.onClose("showEditTemplateNamePopup", false);
      });
    this.props.onClose("showEditTemplateNamePopup", false);
  };

  _onClose = () => {
    this.props.onClose("showEditTemplateNamePopup", false);
  };

  handleKeyDown = e => {
    if (e.keyCode === ENTER_KEY) {
      this._onSubmit();
    }
  };

  _getRenamePopup = () => (
    <Modal open onClose={this._onClose} center closeOnOverlayClick={false}>
      <div
        className="template-nameeditpopup-container"
        data-test="template-nameeditpopup-container">
        <div
          className="template-nameeditpopup-modal-heading"
          data-test="template-nameeditpopup-modal-heading">
          Rename {this.props.docName}
        </div>
        <div className="template-nameeditpopup-form">
          <div className="template-nameeditpopup-form-field">
            <Label htmlFor="userEmail">File Name</Label>
            <input
              className="form-control"
              type="text"
              name="documentName"
              onKeyDown={this.handleKeyDown}
              value={this.state.title || ""}
              onChange={this._onInputChange}
              placeholder="Enter a template name."
              ref={name => {
                this.templateNameInput = name;
              }}
              data-test="template-nameeditpopup-form-field"
            />
          </div>
        </div>
      </div>
      <div className="template-nameeditpopup-footer popup-footer">
        <div className="footer-actions">
          <Button
            className="btn btn-transparent modal-footer-btn cancle-btn"
            data-test="assetitemrenamepopup-cancle-btn"
            onClick={this._onClose}>
            Cancel
          </Button>
          <Button
            data-test="templatenameditpopup_nextfooterbtn"
            onClick={this._onSubmit}>
            Rename
          </Button>
        </div>
      </div>
    </Modal>
  );

  render() {
    const { title, showButtunLoader, errMsg } = this.state;
    const errMsgSpace = errMsg ? (
      <div className="assetmodal-error-message">{errMsg}</div>
    ) : null;
    if (this.props.purpose === "RENAME ONLY") {
      return this._getRenamePopup();
    }
    return (
      <Modal open onClose={this._onClose} center closeOnOverlayClick={false}>
        <div
          className="template-nameeditpopup-container"
          data-test="template-nameeditpopup-container">
          <div
            className="template-nameeditpopup-modal-heading"
            data-test="template-nameeditpopup-modal-heading">
            Name the template before publishing
          </div>
          {errMsgSpace}
          <div className="template-nameeditpopup-form">
            <div className="template-nameeditpopup-form-field">
              <Label htmlFor="userEmail">Rename template</Label>
              <input
                className="form-control"
                type="text"
                name="documentName"
                onKeyDown={this.handleKeyDown}
                value={title}
                onChange={this._onInputChange}
                placeholder="Enter a template name."
                ref={name => {
                  this.templateNameInput = name;
                }}
                data-test="template-nameeditpopup-form-field"
              />
            </div>
          </div>
        </div>
        <div className="template-nameeditpopup-footer popup-footer">
          <div className="footer-actions">
            <Button
              data-test="templatenameditpopup_nextfooterbtn"
              onClick={this._onSubmit}
              isLoading={showButtunLoader}>
              Next
            </Button>
          </div>
        </div>
      </Modal>
    );
  }
}

const mapDispatchToProps = {
  fetchAllDocumentTemplates,
};
export default connect(
  null,
  mapDispatchToProps,
)(TemplateNameEditPopup);



// WEBPACK FOOTER //
// ./src/components/CreateTemplatePopup/TemplateNameEditPopup.js